import * as React from 'react'
import styled from 'styled-components'
import { SbLink } from '../../types'
import CustomLink from '../CustomLink'
import { useI18n } from '../../lib/context/i18n'

export interface NavigationLinkListProps {
  links: Array<{ link: SbLink; text: string }>
}

const Wrapper = styled.nav`
  display: flex;
  flex-direction: column;
`

const Item = styled(CustomLink)`
  background: transparent;
  border-radius: 0.5rem;
  box-shadow: 0 0 0 0 transparent;
  color: ${p => p.theme.colors.black[1]};
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
  padding: 0.5rem;
  text-decoration: none;
  transition: background-color 0.33s, box-shadow 0.33s;

  &:hover {
    box-shadow: 0 0 0 0.2rem ${p => p.theme.colors.black[6]};
  }

  &:hover,
  &:focus-visible,
  &:active {
    background-color: ${p => p.theme.colors.black[6]};
  }

  &:focus {
    background-color: ${p => p.theme.colors.black[7]};
    box-shadow: 0 0 0 0.2rem ${p => p.theme.colors.black[7]};
  }

  &:disabled {
    color: ${p => p.theme.colors.black[4]};
  }
`

export const NavigationLinkList = ({ links }: NavigationLinkListProps) => {
  const { getTranslatedUrlFromLink } = useI18n()
  return (
    <Wrapper>
      {links.map((link, i) => (
        <Item key={i} to={getTranslatedUrlFromLink(link.link)}>
          {link.text}
        </Item>
      ))}
    </Wrapper>
  )
}
